<template>
    <div v-if="templateId" class="mb-3">
        <div class="d-flex align-items-center gap-2">
            <span class="m-0 form-text">Template:</span>

            <span class="flex-fill">{{ template?.title }}</span>

            <!--<FormControlPlainText :value="template?.title" :form-id="formId" class="m-0"/>-->

            <Button ref="button" @click.native="toggleText" :default-class="'btn-light'" class="btn-sm" data-bs-toggle="collapse"
                    data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                {{ buttonText }} template content
            </Button>
        </div>

        <div class="collapse" id="collapseExample">
            <p class="ms-2 mt-3 mb-2 form-text small">
                <template v-if="items?.length">
                    The following content is embedded directly into the page template.
                    <br>
                    Changes will affect all pages of the same template.
                </template>
                <template v-else>
                    No content.
                </template>
            </p>

            <ul class="list-group pb-4">
                <li v-for="item in items" class="list-group-item py-1 pe-2 d-flex align-items-center">
                    <!--
                    todo Error message to be output for IDs referencing missing content:
                    <template v-if="item">-->
                    <div class="flex-fill">
                        <FormPageContentField :content-id="item.id"/>
                    </div>

                    <!--<ContentUsageCount :page-content-id="pageContentData.id" :show-menu="true" class="btn btn-light btn-sm"/>-->

                    <ItemStatusIcons :id="item.id" :table-name="'content'"/>

                    <Button class="btn-sm" @click.native="goToContent(item.id)">
                        <i class="bi-pencil-square"/>
                    </Button>
                    <!--</template>
                    <span v-else>Doesn't exist</span>
                    -->
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import FormPageContentField from "../form/FormPageContentField.vue"
import ContentUsageCount from "../ContentUsageCount.vue"
import ItemStatusIcons from "../ItemStatusIcons.vue"
import Button from "../Button.vue"
import FormControlPlainText from "../form-control/FormControlPlainText.vue"
import FormControlTypeSelect from "../form-control-type/FormControlTypeSelect.vue"

export default {
    name: "PageContentTemplateContent",
    components: {
        FormControlTypeSelect,
        FormControlPlainText,
        Button,
        ItemStatusIcons,
        ContentUsageCount,
        FormPageContentField
    },
    props: {
        formId: String,
        templateId: Number
    },
    data() {
        return {
            open: false
        }
    },
    computed: {
        buttonText() {
            return this.open ? 'Hide' : 'Show'
        }
    },
    asyncComputed: {
        contentIds() {
            return this.$store.dispatch('pageTemplatesContentAreas/getPageTemplatesContentIds', this.templateId)
        },
        items() {
            return this.$store.dispatch('itemData/preload', {
                tableName: 'content',
                ids: this.contentIds
            })
        },
        async template() {
            return await this.$store.dispatch('itemData/get', {
                tableName: 'templates_templates',
                id: this.templateId
            })
        }
    },
    methods: {
        goToContent(contentId) {
            window.location = '/#/content/' + contentId
        },
        toggleText() {
            this.open = this.$refs.button.$el.getAttribute('aria-expanded') === 'true'
        }
    }
}
</script>

<style scoped>

</style>